import { render } from "./CustomerContainers.vue?vue&type=template&id=0cf7dd4a&scoped=true&ts=true"
import script from "./CustomerContainers.vue?vue&type=script&lang=ts"
export * from "./CustomerContainers.vue?vue&type=script&lang=ts"

import "./CustomerContainers.vue?vue&type=style&index=0&id=0cf7dd4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf7dd4a"]])

export default __exports__